export default __webpack_public_path__ + "static/media/puesc-info.c998bfdf.svg";